import {
	PersonTypeEnum,
	SearchDoctorByEnum,
} from './components/ReceiptRegistration/components/ProviderData/constants/types';
import {RequestFormType} from './types';

const DEFAULT_REQUEST_FORM: RequestFormType = {
	provider: {
		professionalType: PersonTypeEnum.PHYSICAL_PERSON,
		searchDoctorBy: SearchDoctorByEnum.DOCUMENT,
		professionalDocument: '',
		professionalCpf: '',
		professionalCode: '',
		councilAcronym: {acronym: '', description: ''},
		councilNumber: '',
		councilState: {
			code: '',
			state: '',
		},
		professionalName: '',
		providerCode: '',
		providerName: '',
		doctorNotFound: false,
		professionalNotFound: false,
		providerUnauthorized: false,
		providerDocumentMatchUserCpf: false,
	},
	patient: {
		patient: {userCode: '', fullName: '', beneficiaryType: '', fullSocialName: null},
		serviceDate: '',
		specialty: {code: '', codeCbo: '', description: ''},
	},
	fiscal: {
		canEmitFiscalDocument: 'yes',
		numFiscalDocument: '',
		priceFiscalDocument: '',
		verifyCode: '',
		state: undefined,
		city: null,
	},
	uploads: undefined,
};

export {DEFAULT_REQUEST_FORM};
